export interface ArticleItem {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
  views: string;
  tags: string[];
}

export const articles: ArticleItem[] = [
  {
    id: 'a1',
    title: '2024年最值得期待的十大国产电影',
    excerpt: '盘点2024年即将上映的国产电影大片，从科幻巨制到文艺佳作，总有一部适合你。',
    content: `<p>2024年是中国电影市场持续复苏和蓬勃发展的一年，众多备受期待的国产大片即将登陆大银幕。本文将为您盘点2024年最值得期待的十大国产电影。</p>
<h3>1. 《封神第二部》</h3>
<p>继第一部的惊艳表现后，《封神第二部》将继续讲述姬发与殷寿之间的传奇对决。导演乌尔善倾力打造的中国神话史诗，视效全面升级，演员阵容更加强大。</p>
<h3>2. 《流浪地球3》</h3>
<p>郭帆导演的科幻系列第三部，将继续探索人类在宇宙中的命运。前两部作品的成功让观众对第三部充满期待，据说将有更加宏大的宇宙场景和更加深刻的人性思考。</p>
<h3>3. 《哪吒2》</h3>
<p>彩条屋影业出品的《哪吒之魔童降世》续集，延续第一部的精良制作和独特美学风格。这一次，哪吒将面对更强大的敌人和更复杂的身世之谜。</p>
<h3>4. 《热辣滚烫2》</h3>
<p>贾玲导演的又一部力作，延续了她特有的幽默风格和温情叙事。影片讲述了一个关于梦想与坚持的励志故事，笑中带泪，温暖人心。</p>
<h3>5. 《酱园弄》</h3>
<p>陈可辛导演的新作，章子怡主演，改编自民国四大奇案之一的"酱园弄杀夫案"。影片以独特的女性视角，讲述了那个时代女性的命运与抗争。</p>
<p>除了以上五部，还有《射雕英雄传：侠之大者》、《解密》、《飞驰人生2》、《第二十条》和《熊出没·逆转时空》等优秀作品值得期待。2024年的中国电影市场必将精彩纷呈，让我们共同期待这些优秀作品的到来。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Movie%20theater%20interior%20with%20red%20curtains%20and%20cinematic%20lighting%2C%20Chinese%20film%20posters%20on%20walls%2C%20elegant%20atmosphere%2C%20warm%20golden%20tones%2C%20artistic%20composition%2C%20movie%20premiere%20vibe&width=1200&height=600&seq=article-cover-01&orientation=landscape',
    category: 'yingshi',
    author: '影视编辑',
    publishDate: '2024-06-15',
    readTime: '8分钟',
    views: '15.6万',
    tags: ['电影', '国产', '2024', '盘点', '推荐'],
  },
  {
    id: 'a2',
    title: '国漫崛起的十年：从大圣归来到深海',
    excerpt: '回顾中国动画电影十年的发展历程，看国漫如何从小众走向主流，从模仿走向创新。',
    content: `<p>2015年，《西游记之大圣归来》以9.56亿票房惊艳亮相，被视为国漫崛起的标志性事件。十年过去，中国动画电影发生了翻天覆地的变化。</p>
<h3>开山之作：大圣归来</h3>
<p>《大圣归来》不仅收获了票房成功，更重要的是它向行业证明了中国动画电影的无限可能。影片以精美的画面、扎实的剧情和创新的改编，打破了国人对国产动画的刻板印象。</p>
<h3>百花齐放：多类型探索</h3>
<p>此后，《大鱼海棠》、《白蛇：缘起》、《哪吒之魔童降世》、《姜子牙》、《深海》、《长安三万里》等作品相继问世，涵盖神话、奇幻、历史、科幻等多种类型，技术水平和艺术表现力不断提升。</p>
<h3>技术与艺术的融合</h3>
<p>从《深海》开创性的"粒子水墨"风格，到《长安三万里》对唐代风貌的精致还原，中国动画人在技术与艺术的融合上不断突破。这些作品不仅在国内获得认可，也在国际舞台上赢得尊重。</p>
<h3>未来的挑战与机遇</h3>
<p>尽管取得了巨大进步，国漫仍面临原创IP不足、人才缺口、产业链不完善等挑战。但随着资本投入增加、政策支持加码、观众审美提升，国漫的未来依然充满希望。下一个十年，我们有理由期待更多优秀的中国动画作品。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20traditional%20ink%20painting%20elements%20blended%20with%20modern%20digital%20art%2C%20dreamy%20fantasy%20landscape%2C%20mythical%20creatures%2C%20beautiful%20color%20palette%2C%20artistic%20composition&width=1200&height=600&seq=article-cover-02&orientation=landscape',
    category: 'dongman',
    author: '动漫编辑',
    publishDate: '2024-06-12',
    readTime: '10分钟',
    views: '12.3万',
    tags: ['国漫', '动画', '电影', '文化', '盘点'],
  },
  {
    id: 'a3',
    title: '综艺节目新风向：从娱乐到文化的蜕变',
    excerpt: '当代综艺节目正在经历深刻变革，从纯娱乐向文化深度转型，开创了综艺节目的新纪元。',
    content: `<p>近年来，中国综艺节目市场发生了显著变化。从《中国诗词大会》到《典籍里的中国》，从《国家宝藏》到《非遗来了》，文化类综艺节目的崛起标志着行业的新风向。</p>
<h3>文化综艺的崛起</h3>
<p>央视推出的《中国诗词大会》率先将传统文化与综艺形式结合，引发全民诗词热潮。此后，《朗读者》、《见字如面》、《国家宝藏》等节目相继走红，证明了文化类综艺的巨大市场潜力。</p>
<h3>形式创新与内容深耕</h3>
<p>新一代文化综艺不再拘泥于传统的竞答模式，而是融入戏剧演绎、实景探访、互动体验等多种形式。《典籍里的中国》通过戏剧化演绎让古籍活起来，《非遗来了》则让观众近距离感受非物质文化遗产的魅力。</p>
<h3>年轻人的文化认同</h3>
<p>令人惊喜的是，文化类综艺在年轻观众中同样获得了热烈反响。这反映了当代年轻人对中华优秀传统文化的认同感和自豪感不断增强，也为综艺行业指明了新的发展方向。</p>
<p>综艺节目从娱乐到文化的蜕变，不仅是行业发展的必然趋势，更是文化自信的生动体现。未来，我们期待看到更多兼具娱乐性和文化内涵的优秀综艺作品。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20show%20studio%20with%20modern%20Chinese%20cultural%20elements%2C%20elegant%20stage%20design%2C%20traditional%20and%20contemporary%20fusion%2C%20warm%20lighting%2C%20professional%20broadcast%20setting&width=1200&height=600&seq=article-cover-03&orientation=landscape',
    category: 'zongyi',
    author: '综艺编辑',
    publishDate: '2024-06-10',
    readTime: '7分钟',
    views: '9.8万',
    tags: ['综艺', '文化', '创新', '趋势', '电视'],
  },
  {
    id: 'a4',
    title: '流媒体时代：短视频如何改变了我们的娱乐方式',
    excerpt: '短视频平台的崛起彻底改变了内容消费模式，探讨这一变革背后的深层原因和未来趋势。',
    content: `<p>从抖音到快手，从B站到小红书，短视频平台已经成为中国人日常生活中不可或缺的一部分。据统计，中国短视频用户规模已超过10亿，日均使用时长超过2小时。短视频究竟如何改变了我们的娱乐方式？</p>
<h3>碎片化消费的胜利</h3>
<p>短视频完美契合了现代人碎片化的时间利用需求。等车、排队、休息间隙，随时随地掏出手机刷几条短视频，已经成为一种全民习惯。15秒到3分钟的时长设置，降低了内容消费的门槛。</p>
<h3>人人都是创作者</h3>
<p>短视频平台极大地降低了内容创作的门槛。一部手机、一个创意，任何人都可以成为内容创作者。这种去中心化的创作模式，催生了海量的UGC内容，也让许多普通人实现了人生逆袭。</p>
<h3>算法推荐的利与弊</h3>
<p>精准的算法推荐让用户总能刷到自己感兴趣的内容，增强了用户粘性。但同时也带来了"信息茧房"和"内容同质化"的问题，如何在个性化推荐和内容多样性之间找到平衡，是平台面临的重要课题。</p>
<h3>未来的发展方向</h3>
<p>随着5G、AI等技术的发展，短视频将朝着更高质量、更多元化的方向发展。中视频、微短剧、互动视频等新形态正在兴起，短视频的未来充满想象空间。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20colorful%20social%20media%20feed%20with%20videos%2C%20modern%20mobile%20interface%2C%20vibrant%20colors%2C%20digital%20lifestyle%20concept%2C%20clean%20and%20minimal%20background&width=1200&height=600&seq=article-cover-04&orientation=landscape',
    category: 'duanshipin',
    author: '科技编辑',
    publishDate: '2024-06-08',
    readTime: '9分钟',
    views: '18.2万',
    tags: ['短视频', '流媒体', '抖音', '趋势', '科技'],
  },
  {
    id: 'a5',
    title: '纪录片推荐：五部改变你世界观的自然纪录片',
    excerpt: '精选五部高分自然纪录片，带你领略地球的壮丽与脆弱，重新思考人与自然的关系。',
    content: `<p>自然纪录片以其震撼的画面和深刻的主题，一直是观众最喜爱的纪录片类型之一。以下是五部不容错过的自然纪录片推荐。</p>
<h3>1. 《地球脉动》系列</h3>
<p>BBC出品的《地球脉动》系列堪称自然纪录片的巅峰之作。从极地到赤道，从深海到高山，用最先进的拍摄技术记录了地球上最壮丽的自然奇观和最动人的生命故事。</p>
<h3>2. 《我们的星球》</h3>
<p>Netflix与WWF合作打造，由大卫·爱登堡爵士担任旁白。影片不仅展示了自然之美，更深刻揭示了气候变化对地球生态系统的影响，唤起人们的环保意识。</p>
<h3>3. 《航拍中国》</h3>
<p>中国自己的自然纪录片佳作，以空中视角俯瞰神州大地，展现了中国壮美的自然风光和丰富的人文景观。目前已播出四季，涵盖了全国所有省份。</p>
<h3>4. 《蓝色星球》系列</h3>
<p>深入海洋世界，揭开深海的神秘面纱。影片中的许多画面都是人类首次拍摄到，令人叹为观止。从微小的浮游生物到巨大的蓝鲸，海洋生命的多样性令人震撼。</p>
<h3>5. 《王朝》</h3>
<p>以动物家族为切入点，讲述企鹅、狮子、老虎、狼、黑猩猩五种动物的家族故事。影片采用叙事手法，让观众像追剧一样关注动物家族的命运，情感共鸣强烈。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20pristine%20nature%20landscape%20with%20mountains%20and%20lake%2C%20documentary%20cinematic%20photography%2C%20golden%20sunset%20light%2C%20wild%20and%20beautiful%2C%20high%20quality%20nature%20photography&width=1200&height=600&seq=article-cover-05&orientation=landscape',
    category: 'jilupian',
    author: '纪录片编辑',
    publishDate: '2024-06-05',
    readTime: '8分钟',
    views: '11.5万',
    tags: ['纪录片', '自然', '推荐', '环保', 'BBC'],
  },
];

export const getArticleById = (id: string) => articles.find(a => a.id === id);
export const getArticlesByCategory = (category: string) => articles.filter(a => a.category === category);
export const getRelatedArticles = (currentId: string, limit: number = 3) => {
  const current = articles.find(a => a.id === currentId);
  if (!current) return [];
  return articles
    .filter(a => a.id !== currentId && a.category === current.category)
    .slice(0, limit);
};